import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { SfaErrorMessage } from './sfa-error-message';

export const SfaCreateNewOrgErrorMessage = () => {
  const intl = useIntl();

  const text = intl.formatMessage(
    {
      id: 'onboarding.sfa.create_new_org_error_message',
      defaultMessage:
        'Select <bold>Confirm and continue</bold> to try connecting again. Alternatively, select <bold>Cancel</bold> to come back and try again later.'
    },
    {
      bold: (chunks: ReactNode) => <b style={{ fontWeight: 500 }}>{chunks}</b>
    }
  );

  return <SfaErrorMessage>{text}</SfaErrorMessage>;
};
